<template>
  <button
    type="button"
    class="flex flex-1 flex-col items-center gap-1.5 pt-0"
    @click="$emit('onClick')"
  >
    <component
      :is="icon"
      width="24"
      height="24"
      :class="
        isActive
          ? 'text-text-positive-primary'
          : 'text-text-neutral-quaternary opacity-40'
      "
    />
    <span
      class="text-center text-xs font-normal"
      :class="
        isActive ? 'text-text-neutral-primary' : 'text-text-neutral-quaternary'
      "
      >{{ label }}</span
    >
  </button>
</template>

<script setup lang="ts">
  import type { Component } from 'vue';

  defineProps<{
    icon: Component;
    label: string;
    isActive: boolean;
  }>();

  defineEmits<{ onClick: [] }>();
</script>
